import { Box, Typography, styled } from '@mui/material';
import Rating from '@mui/material/Rating';
import React from 'react';
import { Lens } from '@mui/icons-material';
import { withStyles } from '@mui/styles';

const RatingComponent = ({ value, label, max = 5, size, ...rest }) => {
	return (
		<div>
			<Typography component="legend">{label}</Typography>
			<StyledRating
				readOnly
				value={parseInt(value || 0)}
				max={max}
				size={size}
				icon={<Lens fontSize="inherit" />}
			/>
		</div>
	);
};

export default RatingComponent;

const StyledRating = withStyles((theme) => ({
	iconFilled: {
		color: theme.palette.primary.main
	},
	iconHover: {
		color: theme.palette.primary.main
	}
}))(Rating);
